// extracted by mini-css-extract-plugin
export default {"root":"root--adcf169","popUp":"popUp--c051ddc","successBg":"successBg--712a65c","errorBg":"errorBg--d2d3cb3","success":"success--b1c3936","error":"error--fdeb5e1"};